<template>
  <div class="app-shell">
    <LoadingOverlay v-if="isLoading"/>
    <div class="mobile-container">
      <router-view />
    </div>
  </div>
</template>

<script type="text/javascript">
import LoadingOverlay from "@/views/components/LoadingOverlay";
import {mapState} from "vuex";

// Session inactivity timeout: after this much idle time a logged-in user is signed
// out and returned to the landing screen. Adjust the duration here.
const INACTIVITY_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
// 'um-activity' is a synthetic event the game view dispatches on our behalf: the Unity game
// runs in an <iframe>, and events inside it never reach this document — without it a player
// mid-round looks idle and gets signed out. See TropicTakeOff.vue.
const ACTIVITY_EVENTS = ['click', 'touchstart', 'touchmove', 'keydown', 'mousemove', 'um-activity'];

export default {
  components: {
    LoadingOverlay
  },
  data() {
    return { idleTimer: null };
  },
  computed: {
    ...mapState(['isLoading'])
  },
  mounted() {
    ACTIVITY_EVENTS.forEach(evt => window.addEventListener(evt, this.onUserActivity, {passive: true}));
    this.resetIdleTimer();
  },
  beforeUnmount() {
    ACTIVITY_EVENTS.forEach(evt => window.removeEventListener(evt, this.onUserActivity));
    if (this.idleTimer) clearTimeout(this.idleTimer);
  },
  methods: {
    onUserActivity() {
      this.resetIdleTimer();
    },
    resetIdleTimer() {
      if (this.idleTimer) clearTimeout(this.idleTimer);
      this.idleTimer = setTimeout(this.onSessionTimeout, INACTIVITY_TIMEOUT_MS);
    },
    onSessionTimeout() {
      // Only act on a real logged-in session — ignore idle time on the public/landing screens.
      let loggedIn = false;
      try { loggedIn = !!sessionStorage.getItem('msisdn'); } catch (e) { /* storage blocked */ }
      if (!loggedIn) {
        this.resetIdleTimer();
        return;
      }
      try {
        sessionStorage.removeItem('msisdn');
        sessionStorage.removeItem('hasLoggedIn');
      } catch (e) { /* storage blocked */ }
      this.$store.commit('setUser', undefined);
      if (this.$route.path !== '/') this.$router.push('/');
    }
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  background: #000;
  min-height: 100vh;
  height: 100%;
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

.app-shell {
  display: flex;
  justify-content: center;
  align-items: stretch;
  min-height: 100vh;
  min-height: 100dvh;
  background: #000;
  width: 100%;
}

.mobile-container {
  width: 100%;
  max-width: 600px;
  min-height: 100vh;
  min-height: 100dvh;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  background: #000;
  -webkit-overflow-scrolling: touch;
}

</style>
